<template>
  <div class="kids-rides">
    <!-- Banner Section -->
    <Banner
      image="https://images.unsplash.com/photo-1568378326405-f4e69c9bb8e7?q=80&w=2070&auto=format&fit=crop"
      title="Kids Rides"
      height="700px"
    />

    <!-- Wavy Divider -->
    <div class="wave-container">
      <svg class="wave-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 400" preserveAspectRatio="none">
        <path class="wave-path" d="M0,96L40,106.7C80,117,160,139,240,154.7C320,171,400,181,480,165.3C560,149,640,107,720,90.7C800,75,880,85,960,112C1040,139,1120,181,1200,181.3C1280,181,1360,139,1400,117.3L1440,96L1440,400L1400,400C1360,400,1280,400,1200,400C1120,400,1040,400,960,400C880,400,800,400,720,400C640,400,560,400,480,400C400,400,320,400,240,400C160,400,80,400,40,400L0,400Z"></path>
      </svg>
    </div>

    <!-- Rides Section -->
    <div class="container">
      <h2>Exciting Rides for Kids</h2>
      <p>Safe, fun, and thrilling experiences designed for kids of all ages.</p>

      <div class="rides-grid">
        <div v-for="(ride, index) in kidsRides" :key="index" class="ride-card">
          <img :src="ride.image" :alt="ride.name" class="ride-image">
          <div class="ride-info">
            <h3>{{ ride.name }}</h3>
            <p>{{ ride.description }}</p>
            <span class="ride-duration">Duration: {{ ride.duration }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Banner from "@/components/Banner.vue";

// Static Ride Data
const kidsRides = ref([
  {
    name: "Mini Water Slides",
    description: "Gentle slides perfect for young adventurers.",
    duration: "10 min",
    image: "https://images.unsplash.com/photo-1533113354175-4ebf406da6b3?q=80&w=800",
  },
  {
    name: "Splash Pad",
    description: "A fun-filled water play area with gentle fountains and sprayers.",
    duration: "Unlimited",
    image: "https://images.unsplash.com/photo-1505028106030-e07ea1bd80c3?q=80&w=800",
  },
  {
    name: "Lazy River (Kids Section)",
    description: "A calm and relaxing river ride just for kids!",
    duration: "15 min",
    image: "https://images.unsplash.com/photo-1620916003121-0dc831755ddc?q=80&w=800",
  },
  {
    name: "Kids Wave Pool",
    description: "Enjoy gentle waves in a safe and shallow water pool.",
    duration: "30 min",
    image: "https://images.unsplash.com/photo-1586190848861-99aa4a171e90?q=80&w=800",
  },
]);
</script>

<style scoped>
/* 📌 Page Styling */
.kids-rides {
  position: relative;
  background: white;
  margin-top: 700px;
}

/* 📌 Wave Effect */
.wave-container {
  position: absolute;
  top: -200px;
  left: 0;
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.wave-top {
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  animation: waveFloat 5s ease-in-out infinite alternate;
}

.wave-path {
  fill: #ffffff;
  filter: drop-shadow(0px -2px 2px rgba(0, 0, 0, 0.1));
}

/* 📌 Container */
.container {
  text-align: center;
  padding: 30px 50px;
  margin-top: -1px;
}

h2 {
  color: #ff6600;
  margin-top: 20px;
}

/* 📌 Rides Grid */
.rides-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 40px;
}

/* 📌 Ride Card */
.ride-card {
  background: #fef3e3;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.ride-card:hover {
  transform: scale(1.05);
}

.ride-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.ride-info {
  padding: 15px;
  text-align: left;
}

.ride-info h3 {
  color: #333;
}

.ride-info p {
  font-size: 14px;
  color: #666;
  margin: 10px 0;
}

.ride-duration {
  display: block;
  font-size: 12px;
  font-weight: bold;
  color: #ff6600;
}

/* 📌 Wave Animation */
@keyframes waveFloat {
  0% {
    transform: translateY(0) scaleY(1.02);
  }
  100% {
    transform: translateY(-10px) scaleY(1.05);
  }
}

/* 📌 Responsive Styling */
@media (max-width: 768px) {
  .wave-container {
    top: -150px;
    height: 170px;
  }

  .container {
    padding: 20px 30px;
  }
}

@media (max-width: 480px) {
  .wave-container {
    top: -100px;
    height: 120px;
  }

  .container {
    padding: 15px 20px;
  }
}
</style>
